(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function initProductEditorial(root) {
      if (!root || root.dataset.peInit) return;
      root.dataset.peInit = '1';

      var variants = [];
      var dataEl = root.querySelector('[data-variants]');
      if (dataEl) {
        try {
          variants = JSON.parse(dataEl.textContent);
        } catch (e) {
          variants = [];
        }
      }

      var idInput = root.querySelector('[data-variant-input]');
      var priceEl = root.querySelector('[data-price]');
      var atc = root.querySelector('[data-atc]');
      var form = root.querySelector('.pe__form');
      var addText = atc ? atc.getAttribute('data-add-text') : 'Add to cart';
      var soldOutText = atc ? atc.getAttribute('data-soldout-text') : 'Sold out';

      function setSelected(buttons, active) {
        for (var i = 0; i < buttons.length; i++) {
          buttons[i].classList.toggle('is-selected', buttons[i] === active);
        }
      }

      function applyVariant(variant) {
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        if (priceEl && variant.price) priceEl.innerHTML = variant.price;
        if (atc) {
          atc.disabled = !variant.available;
          atc.textContent = variant.available ? addText : soldOutText;
        }
      }

      // Size buttons (variants resolved by size value)
      var sizeButtons = root.querySelectorAll('.pe__size[data-size]');
      sizeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          setSelected(sizeButtons, btn);
          var size = btn.getAttribute('data-size');
          var match = variants.filter(function (v) {
            return v.size === size && v.available;
          })[0];
          if (!match) {
            match = variants.filter(function (v) {
              return v.size === size;
            })[0];
          }
          applyVariant(match);
        });
      });

      // Fallback: direct variant buttons (no "size" option)
      var variantButtons = root.querySelectorAll('.pe__size[data-variant-id]');
      variantButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          setSelected(variantButtons, btn);
          var id = btn.getAttribute('data-variant-id');
          var match = variants.filter(function (v) {
            return String(v.id) === String(id);
          })[0];
          applyVariant(match);
        });
      });

      // Mobile: relocate the description below the size chart, and the title
      // above the price (both cross-column, so CSS order can't do it).
      // Restore their original slots on desktop.
      var desc = root.querySelector('.pe__description');
      var title = root.querySelector('.pe__title');
      var details = root.querySelector('.pe__details');
      if (details && window.matchMedia) {
        var descHome = desc && desc.parentNode;
        var descAnchor = desc && desc.nextSibling; // where to put it back on desktop
        var titleHome = title && title.parentNode;
        var titleAnchor = title && title.nextSibling;
        var mq = window.matchMedia('(max-width: 900px)');
        var placeMobileBits = function (mobile) {
          if (mobile) {
            if (title) details.insertBefore(title, details.firstChild); // above price
            if (desc) details.appendChild(desc);
          } else {
            if (title && titleHome) titleHome.insertBefore(title, titleAnchor);
            if (desc && descHome) descHome.insertBefore(desc, descAnchor);
          }
        };
        placeMobileBits(mq.matches);
        mq.addEventListener('change', function (e) {
          placeMobileBits(e.matches);
        });
      }

      // Gallery thumbnails (mobile)
      var mainImage = root.querySelector('[data-main-image]');
      var thumbs = root.querySelectorAll('.pe__thumb');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var full = thumb.getAttribute('data-full');
          if (full && mainImage) {
            mainImage.src = full;
            mainImage.removeAttribute('srcset');
          }
          setSelected(thumbs, thumb);
        });
      });

      // Mobile swipe carousel: sync dots with scroll position + click to jump.
      var stack = root.querySelector('.pe__stack');
      var dots = root.querySelectorAll('.pe__dot');
      if (stack && dots.length) {
        var syncDots = function () {
          var index = Math.round(stack.scrollLeft / stack.clientWidth);
          for (var i = 0; i < dots.length; i++) {
            dots[i].classList.toggle('is-active', i === index);
          }
        };
        stack.addEventListener('scroll', function () {
          window.requestAnimationFrame(syncDots);
        });
        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            var i = parseInt(dot.getAttribute('data-dot'), 10) || 0;
            stack.scrollTo({ left: i * stack.clientWidth, behavior: 'smooth' });
          });
        });
      }

      // AJAX add-to-cart (progressive enhancement)
      var toast = root.querySelector('[data-toast]');
      var toastTimer;
      function showToast() {
        if (!toast) return;
        toast.classList.add('is-visible');
        clearTimeout(toastTimer);
        toastTimer = setTimeout(function () {
          toast.classList.remove('is-visible');
        }, 2200);
      }

      function updateCount(count) {
        var nodes = root.querySelectorAll('[data-cart-count]');
        nodes.forEach(function (n) {
          n.textContent = count;
        });
      }

      if (form && window.fetch) {
        var addUrl = root.getAttribute('data-cart-add-url');
        var cartUrl = root.getAttribute('data-cart-url');

        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (atc) atc.disabled = true;
          var prevText = atc ? atc.textContent : '';
          if (atc) atc.textContent = 'Adding…';

          fetch(addUrl, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          })
            .then(function (res) {
              if (!res.ok) throw new Error('add failed');
              return res.json();
            })
            .then(function () {
              return fetch(cartUrl, { headers: { Accept: 'application/json' } }).then(
                function (r) {
                  return r.json();
                }
              );
            })
            .then(function (cart) {
              updateCount(cart.item_count);
              // Open the global cart drawer with the fresh cart.
              document.dispatchEvent(new CustomEvent('cart:added', { detail: cart }));
              if (atc) {
                atc.disabled = false;
                atc.textContent = prevText || addText;
              }
            })
            .catch(function () {
              // Network/JS failure: fall back to a normal form post.
              form.submit();
            });
        });
      }
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('.pe[data-section-id]');
      roots.forEach(initProductEditorial);
    }

    if (document.readyState !== 'loading') {
      initAll(document);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    }

    // Theme editor support
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["proxy-home"] && !Shopify.designMode) return;
  try {
    
  function initProxyHome() {
    const scope = document.querySelector('[data-proxy-home]');
    if (!scope) return;

    // --- HUD text scramble ---
    // While a glitch clip plays, every character of the overlay text is
    // replaced with a random letter/symbol (re-rolled a few times a second),
    // then snapped back to the real text when the footage resumes.
    let currentTimecode = '00:00:00';
    let currentVidTime = '00:00:00:00';
    const glyphs = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!<>-_/[]{}=+*^?#@%&$';
    const scrambleEls = Array.from(scope.querySelectorAll('[data-proxy-scramble]'));
    const originals = new Map();
    scrambleEls.forEach((el) => originals.set(el, el.textContent));

    // The timecode keeps "ticking" underneath the scramble, so its base text
    // tracks the live value rather than a frozen original.
    const baseTextFor = (el) => {
      if (el.hasAttribute('data-proxy-timecode')) return currentTimecode;
      if (el.hasAttribute('data-proxy-vidtime')) return currentVidTime;
      return originals.get(el) || '';
    };
    const scrambleText = (text) =>
      Array.from(text, (ch) => (ch === ' ' ? ' ' : glyphs[Math.floor(Math.random() * glyphs.length)])).join('');

    let glitchActive = false;
    let scrambleTimer = null;
    const renderScramble = () => {
      scrambleEls.forEach((el) => { el.textContent = scrambleText(baseTextFor(el)); });
    };
    const setGlitch = (active) => {
      if (active === glitchActive) return;
      glitchActive = active;
      // Let glitch clips fill the whole box (black flanks included); footage stays centred.
      scope.querySelector('.proxy-home__video')?.classList.toggle('proxy-home__video--glitch', active);
      if (active) {
        renderScramble();
        scrambleTimer = setInterval(renderScramble, 55);
      } else {
        clearInterval(scrambleTimer);
        scrambleTimer = null;
        scrambleEls.forEach((el) => { el.textContent = baseTextFor(el); });
      }
    };

    // --- Video cycling ---
    // Each main clip is introduced by a random glitch clip, so the sequence is:
    // glitch -> main[0] -> glitch -> main[1] -> ... looping forever.
    const video = scope.querySelector('[data-proxy-video]');
    const sourceEl = scope.querySelector('[data-proxy-source]');
    const listEl = scope.querySelector('[data-proxy-asset-list]');
    const glitchListEl = scope.querySelector('[data-proxy-glitch-list]');
    let urls = [];
    let glitches = [];
    try { urls = JSON.parse(listEl.textContent); } catch (e) { urls = []; }
    try { glitches = JSON.parse(glitchListEl.textContent); } catch (e) { glitches = []; }

    if (video && urls.length) {
      video.removeAttribute('loop');
      let mainIndex = 0;
      let phase = 'glitch'; // what is currently playing

      const playSrc = (src) => {
        // Asset URLs are protocol-relative; on the http:// theme-dev page they
        // resolve to http and eat a 301 per clip — pin them to https.
        sourceEl.src = src.replace(/^\/\//, 'https://');
        video.load();
        // iOS/WebKit only autoplays a *muted* inline video, and the `muted`
        // attribute alone isn't reliably honored for programmatic play — set the
        // property each time (load() can reset it) or the first play() rejects,
        // leaving the hero frozen on frame 1 and the clip cycle never starting.
        video.muted = true;
        video.play().catch(() => {});
      };
      const randomGlitch = () => glitches[Math.floor(Math.random() * glitches.length)];

      const playMain = () => {
        phase = 'main';
        setGlitch(false);
        playSrc(urls[mainIndex]);
      };
      const playGlitchThenMain = () => {
        if (!glitches.length) { playMain(); return; }
        phase = 'glitch';
        setGlitch(true);
        playSrc(randomGlitch());
      };

      video.addEventListener('ended', () => {
        if (phase === 'glitch') {
          playMain();
        } else {
          mainIndex = (mainIndex + 1) % urls.length;
          playGlitchThenMain();
        }
      });

      // Start with a glitch leading into the first main clip.
      playGlitchThenMain();

      // --- Stall watchdog ---
      // The cycle above chains entirely off the 'ended' event. On iOS that
      // event can silently never arrive: the OS pauses muted video on lock /
      // app-switch / Low Power Mode (leaving it *paused*, not *ended*), a clip
      // decode/network error fires 'error' which nothing handles, and any
      // mid-run play() rejection is swallowed above. Each leaves the hero frozen
      // for good. So poll the playback position: if it hasn't advanced for a few
      // seconds, resume (covers interruptions); if that doesn't take, force the
      // sequence past the dead clip by firing the same 'ended' path.
      let lastTime = -1;
      let stallStrikes = 0;
      // A clip that errors out (404, decode failure) never fires 'ended' — skip it.
      video.addEventListener('error', () => video.dispatchEvent(new Event('ended')));
      setInterval(() => {
        // We never pause on purpose — a pause means an interruption; resume it.
        if (video.paused) { video.muted = true; video.play().catch(() => {}); }
        if (video.currentTime === lastTime) {
          // readyState >= 3 means the clip claims it's playable, so no progress
          // is a wedge — skip after ~3s. Below that it's still buffering; on a
          // phone a 14MB clip legitimately takes >3s, so give it ~20s before
          // declaring it dead. Skipping mid-buffer is what cycled first frames.
          const limit = video.readyState >= 3 ? 3 : 20;
          if (++stallStrikes >= limit) {
            stallStrikes = 0;
            video.dispatchEvent(new Event('ended'));
          }
        } else {
          stallStrikes = 0;
        }
        lastTime = video.currentTime;
      }, 1000);
    }

    // --- Video timecode (current playback position, HH:MM:SS:cc) ---
    // currentTime resets to 0 each time a new clip loads, so the timer naturally
    // restarts after the glitch hands off to the next main clip.
    const vtEl = scope.querySelector('[data-proxy-vidtime]');
    if (video && vtEl) {
      const p2 = (n) => String(n).padStart(2, '0');
      const renderVidTime = () => {
        const t = video.currentTime || 0;
        const cs = Math.floor((t % 1) * 100);
        currentVidTime = `${p2(Math.floor(t / 3600))}:${p2(Math.floor(t / 60) % 60)}:${p2(Math.floor(t) % 60)}:${p2(cs)}`;
        // Let the scramble own the element while a glitch is playing.
        if (!glitchActive) vtEl.textContent = currentVidTime;
      };
      // rAF instead of 'timeupdate' (which only fires ~4x/sec) so the
      // millisecond digits tick smoothly.
      const loop = () => { renderVidTime(); requestAnimationFrame(loop); };
      requestAnimationFrame(loop);
    }

    // --- Live clock (the viewer's own device time, HH:MM:SS) ---
    const tcEl = scope.querySelector('[data-proxy-timecode]');
    if (tcEl) {
      const pad = (n) => String(n).padStart(2, '0');
      const updateClock = () => {
        const now = new Date();
        currentTimecode = `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
        // Let the scramble own the element while a glitch is playing.
        if (!glitchActive) tcEl.textContent = currentTimecode;
      };
      updateClock();
      setInterval(updateClock, 1000);
    }

    // --- Live chat ---
    const chatEl = scope.querySelector('[data-proxy-chat]');
    const messages = [
      ['Snow_6',     'lol you guys need to relax'],
      ['CrystalSky', 'ttyl'],
      ['Killer7',    'has anyone heard from boyblush? they haven\'t been online'],
      ['Monostone',  'everything they told us that wasn\'t said is true'],
      ['Ether',      'I know how you feel'],
      ['User64',     'the internet made the world smaller'],
      ['Ekko',       'I keep waiting for someone to understand the things I don\'t know how to say'],
      ['Peroxide_',  'I think I\'m made of the same material as goodbyes'],
      ['Lain222',    'some memories aren\'t events they\'re rooms you keep returning to'],
      ['boyblush',   'i\'m here. just been quiet'],
      ['Halogen',    'reading everything, saying nothing'],
      ['m00nrock',   'who else can\'t sleep'],
      ['Glassine',   'the night gets thinner the longer you look'],
      ['Velour__',   'i miss people i never met'],
      ['Static_K',   'is this thing still on'],
      ['Aphelion',   'i keep dreaming in your handwriting'],
      ['void_kid',   'brb crying about a song from 2007'],
      ['Iridia',     'the silence is loud tonight'],
      ['Soft_Error', 'lifes one big buffer then you die'],
      ['SoftBlue',   'this room smells like the last time i was happy'],
      ['hush.',      'do you ever feel watched by your own life'],
      ['Pearwave',   'send me a song i\'ve never heard'],
      ['ferric_',    'i think the wifi is haunted'],
      ['CrystalSky', 'back. couldn\'t stop thinking about what monostone said'],
      ['Snow_6',     'tell me one thing you\'ve never told anyone'],
      ['Killer7',    'i think boyblush is talking to us through the videos'],
      ['Peroxide',   'I deleted every photo from last summer'],
      ['Lain222',    'did it help?'],
      ['SoftBlue',   'Ive had the same song on repeat all afternoon'],
      ['velour',     'still not sick of it?'],
      ['SoftBlue',   'not even close'],
      ['Aphelion',   'Its strange how some songs only sound right at night'],
    ];

    if (chatEl) {
      const chatBody = chatEl.closest('.proxy-home__chat') || chatEl.parentElement;
      let cursor = 0;
      const renderMessage = (name, msg) => {
        const li = document.createElement('li');
        li.className = 'is-new';
        const n = document.createElement('span');
        n.className = 'name';
        n.textContent = name;
        const m = document.createElement('span');
        m.className = 'msg';
        m.textContent = msg;
        li.appendChild(n);
        li.appendChild(m);
        chatEl.appendChild(li);
        requestAnimationFrame(() => li.classList.remove('is-new'));
      };

      // Is the message column taller than the visible chat area?
      // (chatEl is the <ol>; its layout height reflects the full content even
      // when the parent clips the top via justify-content: flex-end.)
      const overflowing = () => chatEl.scrollHeight >= chatBody.clientHeight;

      // Drop the oldest entries from the top, but keep enough overflow above
      // the fold so the chat always fills the box up to the top edge.
      const trim = () => {
        while (chatEl.children.length > 1 &&
               chatEl.scrollHeight - chatBody.clientHeight > 140) {
          chatEl.children[0].remove();
        }
      };

      // Fill the box from the bottom up until it overflows the top, plus a
      // couple extra so the top message is clipped/faded rather than flush.
      const fill = () => {
        let guard = 0;
        while (!overflowing() && guard < messages.length * 4) {
          renderMessage(...messages[cursor % messages.length]);
          cursor++;
          guard++;
        }
        for (let k = 0; k < 2; k++) {
          renderMessage(...messages[cursor % messages.length]);
          cursor++;
        }
      };
      fill();

      const tick = () => {
        renderMessage(...messages[cursor % messages.length]);
        cursor++;
        trim();
      };

      // Refill if the viewport grows and leaves a gap at the top.
      window.addEventListener('resize', () => {
        if (!overflowing()) fill();
      });

      const jitter = () => 1800 + Math.random() * 2400;
      const schedule = () => {
        setTimeout(() => { tick(); schedule(); }, jitter());
      };
      schedule();

      // --- User-submitted messages (posted as "Anonymous") ---
      const formEl = scope.querySelector('[data-proxy-chat-form]');
      const inputEl = scope.querySelector('[data-proxy-chat-input]');
      if (formEl && inputEl) {
        formEl.addEventListener('submit', (event) => {
          event.preventDefault();
          const text = inputEl.value.trim();
          if (!text) return;
          renderMessage('Anonymous', text);
          trim();
          inputEl.value = '';
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProxyHome);
  } else {
    initProxyHome();
  }

  } catch(e) { console.error(e); }
})();
})();
